import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { WeekdayBubble, WeekdayContainer } from './weekdayBubbleSelector.sc';

// TODO add to styleguide

interface Props {
  weekdays: Array<{ key: string; valKey: string }>;
  defaultVal?: string[];
  onChange: (days: string[]) => void;
}

interface SelectionsState {
  [key: string]: boolean;
}

const WeekdayBubbleSelector: FC<Props> = props => {
  const [selections, setSelections] = useState<SelectionsState>({});
  const [t] = useTranslation();

  useEffect(() => {
    if (props.defaultVal) {
      const vals = props.defaultVal.reduce((values: SelectionsState, value: string) => {
        return { ...values, [value]: true };
      }, {});
      setSelections(vals);
    }
  }, [props.defaultVal]);

  const addSelectedDay = (key: string) => {
    selections[key] = !selections[key];
    const days = Object.entries(selections).reduce((acc: string[], [day, val]) => {
      if (val) {
        acc.push(day);
      }
      return acc;
    }, []);
    // days.push(key);
    props.onChange(days);
  };

  return (
    <WeekdayContainer>
      {props.weekdays.map(day => {
        const selectThisDay = () => addSelectedDay(day.key);
        return (
          <WeekdayBubble key={day.key} onClick={selectThisDay} $selected={selections[day.key]}>
            {t(day.valKey)}
          </WeekdayBubble>
        );
      })}
    </WeekdayContainer>
  );
};

export default WeekdayBubbleSelector;
